module.exports = __webpack_public_path__ + "img/LuckyEgg.4ba78ec1.png";